export enum AssociatedPaymentRegulations {
  MCAM = 'MCAM',
}
